
import Model from '@/app/Model'

export class Permission extends Model {
	static fields () {
		return {
			id: null,
			name: null
		}
	}
}

export function createPermission (data) {
	return Object.freeze(new Permission(data))
}
